import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18.25 9.25v-1.5a2 2 0 0 0-2-2h-4.5m-2.5 11.5h-5.5a2 2 0 0 1-2-2v-9.5m10 0-2-3h-6a2 2 0 0 0-2 2v1m10 0h-10m16.5 8L16 16m0 0-2.25 2.25M16 16l-2.25-2.25M16 16l2.25 2.25"
	})]
});
const ForwardRef = forwardRef(SvgFolderClose);
export { ForwardRef as ReactComponent };
